import React, { useState, useEffect } from "react";
import { FaLinkedin, FaGithub, FaEnvelope } from "react-icons/fa"; // Import icons
import { BsChevronDown } from "react-icons/bs"; // Import arrow icon
import { motion } from "framer-motion"; // For animation

const Home = () => {
  // Function to scroll smoothly to the About section
  const scrollToAbout = () => {
    document.getElementById("about").scrollIntoView({ behavior: "smooth" });
  };

  // Animation state for name
  const [showName, setShowName] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setShowName(false);
      setTimeout(() => setShowName(true), 500); // Restart animation every 15 seconds
    }, 15000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section
      id="home"
      className="h-screen flex flex-col items-center justify-center text-center relative px-6"
      style={{
        backgroundColor: "#fdf2f8", // Very light pink background
      }}
    >
      {/* Social Media Icons (Only visible on Desktop) */}
      <div className="hidden sm:flex flex-col fixed left-4 top-1/3 space-y-4">
        <a href="https://www.linkedin.com/in/sri-deepthi-vootla" target="_blank" rel="noreferrer">
          <FaLinkedin className="text-3xl text-blue-700 hover:text-blue-500 transition-all" />
        </a>
        <a href="https://github.com/srideepthi-vootla" target="_blank" rel="noreferrer">
          <FaGithub className="text-3xl text-black hover:text-gray-600 transition-all" />
        </a>
        <a href="mailto:srideepthivootla1999@gmail.com">
          <FaEnvelope className="text-3xl text-red-500 hover:text-red-400 transition-all" />
        </a>
      </div>

      {/* Profile Image */}
      <img
        src="/assets/profile.png"
        alt="Sri Deepthi Vootla"
        className="w-40 h-40 rounded-full shadow-lg mb-4"
      />

      {/* Introduction */}
      <h1 className="text-4xl font-bold text-black">
        Hey, I'm{" "}
        <motion.span
          key={showName}
          className="text-purple-600 inline-block"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
        >
          Sri Deepthi Vootla
        </motion.span>
      </h1>
      <p className="text-lg text-gray-800 mt-3 max-w-2xl">
        A <strong>Data Science</strong> graduate with expertise in{" "}
        <strong>data analysis</strong>, <strong>machine learning</strong>, and{" "}
        <strong>cloud computing</strong>. Passionate about transforming raw data into
        meaningful insights and building <strong>predictive models</strong> to drive
        data-driven decision-making.
      </p>

      {/* Button to Projects Section */}
      <a
        href="#projects"
        className="inline-block mt-6 px-6 py-3 bg-purple-600 text-white font-semibold rounded-lg shadow-md hover:bg-purple-700 transition-all"
      >
        View My Projects
      </a>

      {/* Scroll Down Animation (Now Clickable) */}
      <motion.div
        initial={{ y: 0 }}
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
        className="absolute bottom-10 flex justify-center cursor-pointer"
        onClick={scrollToAbout}
      >
        <BsChevronDown className="text-3xl text-gray-700 animate-bounce" />
      </motion.div>
    </section>
  );
};

export default Home;